import Vue from "vue";
import SearchResultsWidget from "./components/SearchResults.vue";

import {root} from '@/shared/store/index';
import {actions, getters, mutations, storeState} from './store/index';
import Vuex from 'vuex';

Vue.config.productionTip = false;

let SearchResultsWidgets = document.querySelectorAll('widget-search-results');
if (SearchResultsWidgets.length) {
    SearchResultsWidgets.forEach(el => {

        let state = JSON.parse(JSON.stringify(storeState));
        let store = new Vuex.Store({
            state,
            mutations,
            actions,
            getters,
            modules: {
                root
            }
        });

        new Vue({
            el: el,
            store,
            render(h: any) {
                let language = this.$el.attributes.getNamedItem('language');
                let apiBasePath = this.$el.attributes.getNamedItem('api-base-path');
                let overviewUrl = this.$el.attributes.getNamedItem('overview-url');
                let searchIndex = this.$el.attributes.getNamedItem('search-index');
                let searchEndpoint = this.$el.attributes.getNamedItem('search-endpoint');
                let searchFilters = this.$el.attributes.getNamedItem('search-filters');
                let labels = this.$el.attributes.getNamedItem('labels');
                let isOverview = this.$el.attributes.getNamedItem('is-overview');
                let resultType = this.$el.attributes.getNamedItem('result-type');
                let resultsPerPage = this.$el.attributes.getNamedItem('results-per-page');
                let resultsOrder = this.$el.attributes.getNamedItem('results-order');
                let extraFilter = this.$el.attributes.getNamedItem('extra-filter')
                let imageFallback = this.$el.attributes.getNamedItem('image-fallback')

                return h(SearchResultsWidget, {
                    props: {
                        configRaw: {
                            language: language ? language.value : null,
                            apiBasePath: apiBasePath ? apiBasePath.value : null,
                            overviewUrl: overviewUrl ? overviewUrl.value : null,
                            searchIndex: searchIndex ? searchIndex.value : null,
                            searchEndpoint: searchEndpoint ? searchEndpoint.value : null,
                            searchFilters: searchFilters ? JSON.parse(searchFilters.value) : null,
                            labels: labels ? JSON.parse(labels.value) : null,
                            isOverview: isOverview ? (isOverview.value === 'false' ? false : true) : null,
                            resultType: resultType ? resultType.value : null,
                            resultsPerPage: resultsPerPage ? resultsPerPage.value : null,
                            resultsOrder: resultsOrder ? resultsOrder.value : null,
                            extraFilter: extraFilter ? extraFilter.value : null,
                            imageFallback: imageFallback?.value ?? 'vulogo'
                        }
                    }
                });
            }
        });
    });
}
